import { css } from '@emotion/core';
import { media } from 'styles';

export const padding = css`
  padding-left: 60px;
  ${media.tablet} {
    padding-left: 40px;
  }
`;
